import { CSSProperties } from 'react';

import palette from 'theme/palette';

declare module '@mui/material/styles' {
	interface TypeText {
		subTitle: string;
		helper: string;
		white: string;
		black: string;
	}

	interface TypographyVariants {
		body3: CSSProperties;
		subtitle1: CSSProperties;
		subtitle3: CSSProperties;
		caption1: CSSProperties;
		caption2: CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		body3?: CSSProperties;
	}

	interface TypeModalBackground {
		modalGradient: string;
		color1: string;
		color2: string;
	}

	interface Palette {
		modal: TypeModalBackground;
		banner: string;
	}
	interface PaletteOptions {
		modal?: Partial<TypeModalBackground>;
		banner?: string;
	}
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
	interface TypographyPropsVariantOverrides {
		body3: true;
		subtitle1: true;
		subtitle3: true;
		caption1: true;
		caption2: true;
		headLine: true;
	}
}

export default {
	h1: {
		fontSize: '34px',
		fontWeight: '700',
		lineHeight: '42px',
		padding: '0',
	},
	h2: {
		fontSize: '24px',
		fontWeight: '600',
		lineHeight: '32px',
		letterSpacing: '0.15px',
		padding: '0',
	},
	h3: {
		fontSize: '20px',
		fontWeight: '600',
		lineHeight: '32px',
		letterSpacing: '0.15px',
		padding: '0',
	},
	h4: {
		fontSize: '18px',
		fontWeight: '600',
		lineHeight: '28px',
		padding: '0',
		letterSpacing: '0.4px',
	},
	headLine: {
		fontSize: '30px',
		fontWeight: 400,
		lineHeight: '40px',
	},
	body1: {
		fontSize: '16px',
		fontWeight: '400',
		lineHeight: '26px',
	},
	body2: {
		fontSize: '14px',
		fontWeight: '400',
		lineHeight: '20px',
		letterSpacing: '0.15px',
	},
	body3: {
		fontSize: '12px',
		fontWeight: '500',
		lineHeight: '20px',
	},
	button: {
		fontSize: '16px',
		textTransform: 'none' as const,
	},
	subtitle1: {
		fontSize: '16px',
		fontWeight: '600',
		lineHeight: '22px',
		letterSpacing: '0.4px',
	},
	subtitle2: {
		fontSize: '14px',
		fontWeight: '600',
		lineHeight: '22px',
		letterSpacing: '0.15px',
	},
	subtitle3: {
		fontSize: '12px',
		fontWeight: '600',
		lineHeight: '18px',
	},
	caption1: {
		fontSize: '12px',
		fontWeight: '400',
		lineHeight: '20px',
		letterSpacing: '0.15px',
		color: palette.text.secondary,
	},
	caption2: {
		fontSize: '10px',
		fontWeight: '400',
		lineHeight: '16px',
	},
	fontFamily: ['MuseoSansCyrl'].join(','),
};
